(() => {
  if (window.sbReleaseInstalled) return;
  window.sbReleaseInstalled = true;
  const instances = new Map();
  function bind(scope = document) {
    scope.querySelectorAll('[data-sb-release]').forEach(root => {
      if (instances.has(root)) return;
      const prose = root.querySelector('.sb-release__prose');
      const progress = root.querySelector('.sb-release__progress');
      const reading = root.querySelector('.sb-release__reading');
      if (!prose || !progress || !reading) return;
      const links = [...root.querySelectorAll('.sb-release__contents a')];
      links.forEach(link => { link.hidden = !root.querySelector(link.hash); });
      let frame = 0;
      const update = () => {
        frame = 0;
        const start = reading.getBoundingClientRect().top + scrollY;
        const end = prose.getBoundingClientRect().bottom + scrollY;
        const value = Math.min(1, Math.max(0, (scrollY - start) / Math.max(1, end - start - innerHeight)));
        progress.style.setProperty('--reading-progress', value);
        progress.setAttribute('aria-valuenow', Math.round(value * 100));
        let current = links.find(link => !link.hidden);
        links.forEach(link => { const target = root.querySelector(link.hash); if (target && target.getBoundingClientRect().top < innerHeight * .35) current = link; });
        links.forEach(link => { if (link === current) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      addEventListener('scroll', schedule, {passive:true});
      addEventListener('resize', schedule);
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      observer?.observe(root);
      instances.set(root, () => { cancelAnimationFrame(frame); observer?.disconnect(); removeEventListener('scroll', schedule); removeEventListener('resize', schedule); });
      schedule();
    });
  }
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) { cleanup(); instances.delete(root); }
  });
})();
